module.exports = __webpack_public_path__ + "static/media/sanguo-6.e3f566ca.png";